import MobileScanDevices from '@/lib/MobileScanDevices';

export const SET_AVAILABILITY = 'SET_AVAILABILITY';
export const SET_ARM_RANGES = 'SET_ARM_RANGES';
export const SET_ARM_DETECTION_START = 'SET_ARM_DETECTION_START';
export const SET_PLATFORM = 'SET_PLATFORM';
export const SET_OS_VERSION = 'SET_OS_VERSION';
export const SET_APP_VERSION = 'SET_APP_VERSION';
export const SET_DEVICE_NAME = 'SET_DEVICE_NAME';
export const SET_DEVICE_MODEL_NAME = 'SET_DEVICE_MODEL_NAME';
export const SET_DEVICE_MODEL_ID = 'SET_DEVICE_MODEL_ID';
export const SET_SCANNER_ID = 'SET_SCANNER_ID';

const hardware = {
  namespaced: true,
  state: () => ({
    bluetooth: {
      available: false,
    },
    camera: {
      available: true,
    },
    armDetection: {
      range: {
        minL: 150,
        maxL: 200,
        minR: 150,
        maxR: 200,
      },
      start: false,
    },
    platform: '',
    osVersion: '',
    appVersion: '',
    deviceName: '',
    deviceModel: '',
    deviceModelId: '',
    scannerId: '',
  }),
  mutations: {
    [SET_AVAILABILITY](state, payload) {
      const { name, isAvailable } = payload;
      state[name].available = isAvailable;
    },
    [SET_ARM_RANGES](state, payload) {
      const [minL, maxL, minR, maxR] = payload;
      state.armDetection.range = { minL, maxL, minR, maxR };
    },
    [SET_ARM_DETECTION_START](state, start) {
      state.armDetection.start = start;
    },
    [SET_SCANNER_ID](state, id) {
      state.scannerId = id;
    },
    [SET_PLATFORM](state, platform) {
      state.platform = platform;
    },
    [SET_OS_VERSION](state, osVersion) {
      state.osVersion = osVersion;
    },
    [SET_APP_VERSION](state, appVersion) {
      state.appVersion = appVersion;
    },
    [SET_DEVICE_NAME](state, deviceName) {
      state.deviceName = deviceName;
    },
    [SET_DEVICE_MODEL_NAME](state, deviceModel) {
      state.deviceModel = deviceModel;
    },
    [SET_DEVICE_MODEL_ID](state, deviceModelId) {
      state.deviceModelId = deviceModelId;
    },
  },
  actions: {
    toggleArmDetection({ commit }, start) {
      console.log('toggleArmDetection', start);
      commit(SET_ARM_DETECTION_START, start);
    },
    setArmsRange({ commit }, data) {
      console.log('SET_ARM_RANGES', JSON.stringify(data));
      commit(SET_ARM_RANGES, data);
    },
  },
  getters: {
    isBluetoothAvailable: state => state.bluetooth.available,
    isCameraAvailable: state => state.camera.available,
    isMobileScanCapable: state => MobileScanDevices.indexOf(state.deviceModelId) > -1,
    leftRange: state => [state.armDetection.range.minL, state.armDetection.range.maxL],
    rightRange: state => [state.armDetection.range.minR, state.armDetection.range.maxR],
    hasArmDetectionStarted: state => state.armDetection.start,
    isAndroid: state => state.platform === 'android',
    isIOS: state => state.platform === 'ios',
    isIOS15: (state, getters) => getters.isIOS && state.osVersion.indexOf('15') === 0,
    platformInfo: state => `${state.platform} ${state.osVersion}`,
    deviceInfo: state => `${state.deviceModel} (${state.deviceModelId})`,
  },
};

export default hardware;
